export default __webpack_public_path__ + "static/3d-next-react-book-2-86a21388e136de1f035a102890ff0694.png";